// extracted by mini-css-extract-plugin
export default {"container":"TariffLimitRow_container__sxTCb","value":"TariffLimitRow_value__bmD-l","label":"TariffLimitRow_label__jqwwc"};